(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireafa4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireafa4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eejBl", function(module, exports) {
parcelRequire("5J9YX");
parcelRequire("lNUmu");

});
parcelRegister("5J9YX", function(module, exports) {


var $aPvYT = parcelRequire("aPvYT");
document.querySelectorAll('.copy').forEach((elem)=>{
    elem.addEventListener('click', ()=>{
        // Check if the clipboard api is supported
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!navigator.clipboard) return;
        (0, $aPvYT.discard)(navigator.clipboard.writeText(elem.innerText));
    });
});

});
parcelRegister("aPvYT", function(module, exports) {

$parcel$export(module.exports, "discard", function () { return $d559e0affdf1e3ba$export$584af591d945b55a; });
const $d559e0affdf1e3ba$var$error = console.error.bind(console);
function $d559e0affdf1e3ba$export$584af591d945b55a(p) {
    p.then(()=>{}).catch($d559e0affdf1e3ba$var$error);
}
function $d559e0affdf1e3ba$export$7603b7d5ef1ac1a7(m, worker) {
    $d559e0affdf1e3ba$export$584af591d945b55a(m.runExclusive(worker));
}

});


parcelRegister("lNUmu", function(module, exports) {
document.querySelectorAll('span').forEach((elem)=>{
    if (!elem.hasAttribute('data-reveal')) return;
    $da73427a6e754cdd$export$7365a963a6092e93(elem, 10000);
});
function $da73427a6e754cdd$export$7365a963a6092e93(span, hideDelay) {
    const content = span.getAttribute('data-reveal') ?? '(no content)';
    let isHidden = true;
    // handler to hide the element
    const hide = ()=>{
        isHidden = true;
        span.innerText = '(click to reveal)';
    };
    hide();
    const reveal = ()=>{
        isHidden = false;
        const code = document.createElement('code');
        code.append(content);
        code.addEventListener('click', (evt)=>{
            evt.preventDefault();
            // Check if the clipboard api is supported
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if (!navigator.clipboard) return;
            navigator.clipboard.writeText(content).then(()=>{}).catch(console.error.bind(console));
        });
        code.style.userSelect = 'all';
        span.innerHTML = '';
        span.append(code);
    };
    span.addEventListener('click', (evt)=>{
        evt.preventDefault();
        if (!isHidden) return;
        reveal();
        setTimeout(hide, hideDelay) // hide again after 1 second
        ;
    });
}

});



parcelRequire("eejBl");
})();
//# sourceMappingURL=User.f26d7f81.js.map
